export interface ReportSubmissionError {
  title: string;
  message: string;
  requestId?: string;
}

const getStringProperty = (value: unknown, key: string) => {
  if (!value || typeof value !== 'object' || !(key in value)) return undefined;
  const candidate = (value as Record<string, unknown>)[key];
  return typeof candidate === 'string' && candidate.trim() ? candidate.trim() : undefined;
};

const getNumberProperty = (value: unknown, key: string) => {
  if (!value || typeof value !== 'object' || !(key in value)) return undefined;
  const candidate = (value as Record<string, unknown>)[key];
  return typeof candidate === 'number' ? candidate : undefined;
};

export function getReportSubmissionError(error: unknown): ReportSubmissionError {
  const requestId = getStringProperty(error, 'requestId');
  const status = getNumberProperty(error, 'status');

  if (status === 401 || status === 403) {
    return {
      title: 'No se ha podido verificar tu sesión',
      message: 'Vuelve a iniciar sesión y reintenta el envío. Lo que has escrito sigue aquí.',
      requestId
    };
  }

  if (status === 413) {
    return {
      title: 'El reporte es demasiado extenso',
      message: 'Acorta la descripción y vuelve a intentarlo.',
      requestId
    };
  }

  return {
    title: 'No hemos podido confirmar el envío',
    message: 'Conservamos lo que has escrito. Reinténtalo cuando vuelva la conexión; no se duplicará el reporte.',
    requestId
  };
}
